import { FeedbackMetadataField } from '@modules/feedback/types';
import { getMetadataValues } from '@modules/feedback/utils';
import { SourceDataV2ViewFragment } from 'generated/graphql';

interface getMappedFeedbackSourceMetadataFieldsParams {
  metadataFields: SourceDataV2ViewFragment['metadata'];
}

export const getMappedFeedbackSourceMetadataFields = ({
  metadataFields,
}: getMappedFeedbackSourceMetadataFieldsParams): FeedbackMetadataField[] => {
  const mappedMetadataFieldsWithValues: FeedbackMetadataField[] =
    metadataFields?.map((metadata) => ({
      ...metadata,
      key: metadata.key,
      values: getMetadataValues(metadata),
      metadataValue: metadata.value,
      metadataFieldKey: metadata.field,
    })) ?? [];

  return mappedMetadataFieldsWithValues;
};
